import React, {useCallback, useEffect, useState} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {IMAGE_URL} from '../../utility/constants';
import {useDispatch, useSelector} from 'react-redux';
import {Dropdown} from 'react-bootstrap';
import {publicBranchChange} from '../../redux/actions';
import useQuery from '../../hooks/useQuery';
import {defaultClientBranch} from '../../utility/clientLocation';

const branchesForCompany = company => {
  const branches = company?.branches;
  if (Array.isArray(branches)) return branches;
  if (Array.isArray(branches?.items)) return branches.items;

  return [];
};

const SignInHeader = ({
  publicBooking,
  publicCompany = null,
  hideBranchSelector = false,
  authReturnPath = '',
  onAuthAction,
}) => {
  const history = useHistory();
  const location = useLocation();
  const query = useQuery();
  const branchIdUrlQuery = query.get('branchId');
  const sessionIdUrlQuery = query.get('sessionId');
  const fromCheckInUrlQuery = query.get('fromCheckIn');
  const typeUrlQuery = query.get('type');
  const authDetails = useSelector(state => state.auth);
  const publicUser = useSelector(state => state.publicUser);
  const [activeCompany, setActiveCompany] = useState(null);
  const [activeBranch, setActiveBranch] = useState(null);
  const dispatch = useDispatch();
  const activeCompanyBranches = branchesForCompany(activeCompany);
  const companyName =
    publicCompany?.name ||
    publicCompany?.companyName ||
    activeCompany?.name ||
    activeCompany?.companyName ||
    authDetails?.companyData?.name ||
    authDetails?.companyData?.companyName ||
    publicUser?.companyName ||
    '';
  const companyImage =
    publicCompany?.imageUrl ||
    publicCompany?.companyImage ||
    activeCompany?.imageUrl ||
    authDetails?.companyData?.imageUrl ||
    publicUser?.companyImage ||
    '';
  const dropdownName = activeBranch?.name || companyName;

  // Function to update URL with branch ID
  const updateUrlWithBranchId = branchId => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('branchId', branchId);
    // Preserve existing query parameters
    if (typeUrlQuery) {
      searchParams.set('type', typeUrlQuery);
    }
    if (sessionIdUrlQuery) {
      searchParams.set('sessionId', sessionIdUrlQuery);
    }
    if (fromCheckInUrlQuery) {
      searchParams.set('fromCheckIn', fromCheckInUrlQuery);
    }
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const loadBranchData = useCallback(() => {
    const headerCompanyData = publicCompany || authDetails.companyData;
    const branchCompanyData = authDetails.companyData || publicCompany;

    if (headerCompanyData || branchCompanyData) {
      const companyData = {
        ...(branchCompanyData || {}),
        ...(headerCompanyData || {}),
        branches: branchCompanyData?.branches || headerCompanyData?.branches,
      };
      const branches = branchesForCompany(companyData);
      setActiveCompany(companyData);
      const configuredDefaultBranch = defaultClientBranch(companyData);
      setActiveBranch(configuredDefaultBranch);
      if (branchIdUrlQuery) {
        const requestedBranch = branches.find(item => item?.id === branchIdUrlQuery);
        if (requestedBranch) {
          setActiveBranch(requestedBranch);
          dispatch(
            publicBranchChange({
              companyId: companyData?.id || companyData?.companyId,
              branchSelected: requestedBranch,
              sessionId: sessionIdUrlQuery,
              isFromCheckIn: fromCheckInUrlQuery,
            })
          );
          return;
        }
      }
      dispatch(
        publicBranchChange({
          companyId: companyData?.id || companyData?.companyId,
          branchSelected: configuredDefaultBranch,
          sessionId: sessionIdUrlQuery,
          isFromCheckIn: fromCheckInUrlQuery,
        })
      );
      // Update URL with default branch if no branchId is in the URL
      if (configuredDefaultBranch) {
        updateUrlWithBranchId(configuredDefaultBranch.id);
      }
    }
  }, [authDetails.companyData, branchIdUrlQuery, dispatch, publicCompany]);

  useEffect(() => {
    loadBranchData();
  }, [loadBranchData]);

  return (
    <header id="page-topbar">
      <nav className="navbar-header position-relative">
        <div className="cf-logo pl-4">
          {/* <Link to="/" className="logo">
            <img src={logoLight} alt="" width="70" />
          </Link> */}
        </div>
        {publicBooking && (
          <div className="external-login-hdr company_logo top-50 start-50">
            <Link to="/" className="logo logo-light">
              <img
                src={companyImage ? IMAGE_URL + companyImage : ''}
                alt=""
                className="img-fluid ex-logo"
              />
            </Link>
            <span className="text-dark text-truncate ml-3">{companyName}</span>
          </div>
        )}
        {!hideBranchSelector && (
          <div className="external-login-hdr second-dropdown company_logo  top-50 start-50">
            <Dropdown>
              {/* <div className="row"> */}
              <div className="col-12">
                <div className="text-center">
                  <div className="row d-inline-block">
                    <span className="text-dark text-truncate name">{dropdownName}</span>
                    <Dropdown.Toggle id="company_dropdown" className="toggle">
                      <i className="fas fa-chevron-down user-dropdown" aria-hidden="true"></i>
                    </Dropdown.Toggle>
                  </div>
                </div>
              </div>
              {/* </div> */}

              <Dropdown.Menu className="company dropdown-menu show py-4">
                {activeCompanyBranches.map((item, index) => (
                  <Dropdown.Item
                    className="dropdown-item border-bottom p-4"
                    key={index}
                    onClick={() => {
                      dispatch(
                        publicBranchChange({
                          companyId: activeCompany?.id,
                          branchSelected: item,
                          sessionId: sessionIdUrlQuery,
                        })
                      );
                      setActiveBranch(item);
                      // Update URL with new branch ID
                      updateUrlWithBranchId(item?.id);
                    }}
                    active={activeBranch?.id === item?.id}
                  >
                    <img
                      src={IMAGE_URL + item?.imageUrl}
                      alt=""
                      className="img-fluid ex-logo"
                      // height="30"
                      width="40"
                    />
                    <span className="ml-3">{item?.name}</span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}

        <div className="d-flex">
          <div className="_btnGrp text-center">
            <Link
              className="btn btn-primary"
              to={
                authReturnPath
                  ? {
                      pathname: '/login',
                      search: `?returnUrl=${encodeURIComponent(authReturnPath)}`,
                      state: {from: authReturnPath},
                    }
                  : '/login'
              }
              onClick={() => onAuthAction?.(authReturnPath)}
            >
              Sign In / Sign Up
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default SignInHeader;
